module.exports = __webpack_public_path__ + "static/media/prod-cta-pride-4t-sae-10w-30.42c74072.png";